import React from 'react';
import {  Show,
ShowButton,List,EditButton,SimpleForm,
 Datagrid,RichTextInput,DisabledInput,TextInput,Edit,
TextField, RichTextField ,SimpleShowLayout,
ReferenceInput, SelectInput,DateField,BooleanField,NumberField
 }
from 'admin-on-rest/lib/mui';

export const FraudAlertsList = (props) => (
    <List title="הונאה - התראות" {...props}>
        <Datagrid>
            
            
        <TextField label="בית עסק " source="buisiness_id"/> 
           <NumberField label="ממוצע עסקאות חודשי" source="total"  locales="he-IL" options={{ style: 'currency', currency: 'ILS' }}/>
           
           <NumberField label="סהכ הונאות" source="totalIskot"  locales="he-IL" options={{ style: 'currency', currency: 'ILS' }}/>
           <NumberField label="מספר דיווחי הונאה" source="countFraud"  locales="he-IL" />
           
           <NumberField label="שנה " source="year"/>
           <NumberField label="חודש " source="month"/>
           
           <NumberField  label="יחס הונאות/מחזור" source="ratio" locales="he-IL" options={{ style: 'percent', minimumFractionDigits: 1,maximumFractionDigits: 2 }} />
           <BooleanField label="מעל 3000 " source="fraudAlert2" />
           <BooleanField label="מעל 4% " source="fraudAlert1"/>
           

            <ShowButton />
        </Datagrid>
    </List>
);

const PostTitle = ({ record }) => {
    return <span> {record ? `${record.id}` : ''}</span>;
};

       
         





              



// WEBPACK FOOTER //
// ./src/components/Fraud/fraudsAlerts.js